import { PRMarinaNode } from '@sketch-hq/sketch-web-renderer'

/**
 * Whether the node sits inside another frame.
 *
 * A frame nested in a frame is that frame's content rather than an entity of
 * its own - nothing anchors to it and it isn't opened from the canvas - so it
 * gets no overlay. Sections don't nest inside frames, so only frame ancestry
 * matters here.
 */
export function hasFrameAncestor(node: PRMarinaNode | null): boolean {
  for (
    let ancestor = node?.getParentNode() ?? null;
    ancestor;
    ancestor = ancestor.getParentNode()
  ) {
    if (ancestor.isFrame()) {
      return true
    }
  }

  return false
}
